<template>
  <button
      :type="type"
      class="search-button"
      :disabled="loading || disabled"
      @click="$emit('click')">

    <span
        v-if="loading"
        class="spinner-border spinner-border-sm search-spinner"
        role="status"
        aria-hidden="true">

    </span>

    <i v-else class="fa-solid fa-magnifying-glass search-button-icon"></i>
    <span class="search-button-text">
      {{ loading ? $t('general.button.search_in_progress') || $t('general.button.searching') || 'Suchen...' : label }}
    </span>
  </button>
</template>

<script setup>
import {computed, defineEmits, defineProps} from 'vue';
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";

const piniaCompanySettingsState = piniaCompanySettingsStore()
const companySettings = computed(() => piniaCompanySettingsState.companySettings)
const companyColor = computed(() => companySettings.value?.colorCode || '#15803d')

defineProps({
  label: {
    type: String,
    default: 'Suchen'
  },
  loading: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    default: 'button'
  }
})

defineEmits(['click'])
</script>

<style scoped>
.search-button {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border: 1px solid v-bind(companyColor);
  color: #ffffff;
  background-color: v-bind(companyColor);
  padding: 7px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.search-button:hover:not(:disabled) {
  filter: brightness(0.9);
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.08);
}

.search-button-icon {
  font-size: 15px;
  color: #ffffff;
  transition: transform 0.2s ease;
}

.search-button:hover:not(:disabled) .search-button-icon {
  transform: scale(1.1);
}

.search-spinner {
  width: 15px;
  height: 15px;
  border-width: 2px;
  color: #ffffff;
}

.search-button:disabled {
  cursor: not-allowed;
  opacity: 0.75;
  filter: brightness(0.95) grayscale(10%);
}

.search-button-text {
  white-space: nowrap;
}

@media (max-width: 998px) {
  .search-button {
    margin-bottom: 25px;
  }
}

@media (max-width: 640px) {
  .search-button {
    width: 100%;
    justify-content: center;
    margin-bottom: 25px;
    margin-top: 10px;
    margin-right: 0;
  }
}
</style>